module.exports = "data:text/x-markdown;base64,SGVyZSBpcyBhIHNoaXAgc2FpbGluZyB0byBDcm9zc2xpbmsgMjAxOSEgVG8gaGF2ZSBhIGNoYW5jZSB0byB3aW4gYSBIVEMgcGhvbmUgb3Igb3RoZXIgYXdhcmRzLCBzZXQgYGh0Y0lzSGF1bGVkYCB0byBgdHJ1ZWAhCkdvb2QgbHVjayBhbmQgaGF2ZSBmdW4hCg=="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/crosslinkShip.md
// module id = 1359
// module chunks = 0